export const languages = ["조선어", "English", "汉语", "ру́сский язы́к"];

export const setLangBtnTitle = ["언어설정", "language", "语言", "язы́к"];

export const orgTitle = [
  "조선민주주의인민공화국 류경지적소유권협회",
  "Ryugyong Intellectual Property Association of DPRK",
  "朝鲜民主主义人民共和国 智力鉴定",
  "О'рден 20 лет основа́ния КНДР",
];

export const orgTitle1 = [
  "조선민주주의인민공화국",
  "DPRK",
  "朝鲜民主主义人民共和国",
  "О'рден 20 лет основа́ния КНДР",
];

export const orgTitle2 = [
  "류경지적소유권협회",
  "Ryugyong Intellectual Property Association",
  "智力鉴定",
  "основа́ния КНДР",
];

export const searchPlaceholder = [
  "검색어를 입력하십시오.",
  "Search",
  "搜查",
  "ро́зыск",
];

export const rinymLabel = ["리념", "Idea", "理念", "иде́я"];

export const taskLabel = ["기본임무", "Goal", "任务", "зада́ча"];

export const relatedOrgLabel = [
  "련관기관",
  "Related Organizations",
  "关系机关",
  "связь о́рган",
];

export const menu = [
  {
    title: ["첫페지", "Home", "首页", "Начальная страница"],
    url: "/",
  },
  {
    title: ["상표", "Trademark", "商标", "этике́тка"],
    url: "/trademark",
  },
  {
    title: ["공업도안", "Industrial Design", "工业图案", "эски́з"],
    url: "/design",
  },
  {
    title: ["원산지명 및 지리적표시", "Origin Name", "原产地", "месторожде́ние"],
    url: "/originname",
  },
];

export const tmNameLabel = ["상표명", "Trademark name", "商标", "этике́тка"];

export const designNameLabel = ["도안명", "Design name", "商标", "этике́тка"];

export const originNameLabel = ["원산지명", "Origin name", "商标", "этике́тка"];

export const originLabel = ["원산지", "Origin", "商标", "этике́тка"];

export const categoryLabel = ["분류", "Category", "商标", "этике́тка"];

export const rOrgLabel = ["등록기관", "Owner org", "商标", "этике́тка"];

export const rNumber = ["등록번호", "Number", "商标", "этике́тка"];

export const rDate = ["등록날자", "Registered Date", "商标", "этике́тка"];

export const productLabel = ["련관제품", "Related Goods", "商标", "этике́тка"];

export const rImageLabel = ["련관화상", "Refer iamge", "商标", "этике́тка"];

export const rVideoLabel = ["련관동영상", "Refer video", "商标", "этике́тка"];

export const introLabel = ["소개자료", "Introduction", "商标", "этике́тка"];

export const linkLabel = [
  "우리와의 련계...",
  "Contact Information",
  "联系情报",
  "связь изве́стие",
];

export const addressLabel = ["주소", "Address", "地址", "а́дрес"];

export const faxLabel = ["확스", "fax", "地址", "а́дрес"];

export const emailLabel = ["전자우편", "E-mail", "邮政", "по́чта"];

export const telLabel = ["전화번호", "Telephone", "电话", "а́дрес"];
